<template>
  <RevDrawer
    :close-button-label="i18n(translations.closeButtonLabel, { partnerLabel })"
    :name
    :title="i18n(translations.drawerTitle, { partnerLabel })"
    @open="fetchOffer"
  >
    <template #body>
      <div v-if="isLoading" class="flex justify-center py-32">
        <RevSpinner size="large" />
      </div>

      <div v-else-if="offer?.guarantees" class="space-y-32 pb-[5rem]">
        <div class="mb-8">
          <RevIllustration
            v-if="offer?.partner.logo?.url"
            :alt="offer?.partner.logo?.description"
            :height="24"
            :src="offer?.partner.logo?.url"
            :width="24"
          />
        </div>

        <h1 class="heading-1">
          {{ i18n(translations.title, { partnerLabel }) }}
        </h1>

        <div v-for="guarantee in offer.guarantees" :key="guarantee.title">
          <h2 class="heading-2">{{ guarantee.title }}</h2>
          <div class="body-1">{{ guarantee.description }}</div>
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { MobilePlanOfferWithPerks } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { RevSpinner } from '@ds/components/Spinner'

import translations from './MobilePlanAssistanceDrawer.translations'

const i18n = useI18n()

const props = defineProps<{
  name: string
  offerId: string
  partnerLabel: string
}>()

const $httpFetch = useHttpFetch()

const offer = ref<MobilePlanOfferWithPerks | null>(null)
const isLoading = ref(false)

async function fetchOffer() {
  isLoading.value = true

  try {
    offer.value = await $httpFetch('/mobile-plan/api/v1/offers/:offerId', {
      pathParams: { offerId: props.offerId },
    })
  } finally {
    isLoading.value = false
  }
}
</script>
